import React from "react";
import {
	ECRBRecordCode,
	ECRBRecordState,
	TCRBBackendRecord,
} from "../../../../redux/app/crb/@types";

import CRBA1Preview from "./previews/CRBA1Preview";
import CRBB1Preview from "./previews/CRBB1Preview";
import CRBC1Preview from "./previews/CRBC1Preview";
import CRBD1Preview from "./previews/CRBD1Preview";
import CRBE1Preview from "./previews/CRBE1Preview";
import CRBF1Preview from "./previews/CRBF1Preview";
import CRBG1Preview from "./previews/CRBG1Preview";
import CRBH1Preview from "./previews/CRBH1Preview";
import CRBI1Preview from "./previews/CRBI1Preview";
import CRBJ1Preview from "./previews/CRBJ1Preview";
import CRBK0Preview from "./previews/CRBK0Preview";
import CRBK1Preview from "./previews/CRBK1Preview";
import CRBK2Preview from "./previews/CRBK2Preview";
import CRBTableRows from "./CRBTableRows";
import moment from "moment";

type OwnProps = {
	crbRecord: TCRBBackendRecord;
};
type CRBPreviewerProps = OwnProps;
function CRBPreviewer(props: CRBPreviewerProps) {
	const { crbRecord } = props;
	const isStrikedOff = crbRecord.state === ECRBRecordState.STRIKED_OFF;
	const isEditOfApprovedRecord = !!crbRecord.dateOfApprovedRecordEdit;

	function renderMain() {
		if (isEditOfApprovedRecord) return renderEditedApprovedRecord();
		return renderRecord(crbRecord, isStrikedOff);
	}

	function renderEditedApprovedRecord() {
		if (!crbRecord.dateOfApprovedRecordEdit) return null;
		return (
			<>
				{renderEditCorrectionLine()}
				{renderRecord(
					{ ...crbRecord, selectedDate: crbRecord.dateOfApprovedRecordEdit },
					isStrikedOff
				)}
				{renderStruckOffVersionOfEdit()}
			</>
		);
	}
	function renderEditCorrectionLine() {
		if (!crbRecord.dateOfApprovedRecordEdit) return null;
		const formattedEditDate = moment(
			crbRecord.selectedDate,
			"YYYY-MM-DD"
		).format("DD-MMM-YYYY");

		return (
			<CRBTableRows
				record={crbRecord}
				tableRows={[
					[
						formattedEditDate,
						"O",
						"-",
						"ENTRY PERTAINING TO AN EARLIER INCORRECT OPERATIONAL ENTRY",
					],
				]}
			/>
		);
	}

	function renderStruckOffVersionOfEdit() {
		if (!crbRecord.editVersions) return null;
		const oldVersionOfRecord = {
			...crbRecord.editVersions[0],
			state: ECRBRecordState.STRIKED_OFF,
		};
		return <CRBPreviewer crbRecord={oldVersionOfRecord} />;
	}

	function renderRecord(
		recordToRender: TCRBBackendRecord,
		isStrikedOff: boolean = false
	) {
		switch (recordToRender.recordCode) {
			case ECRBRecordCode.CRBA:
				return (
					<CRBA1Preview
						crbRecord={recordToRender}
						isStrikedOff={isStrikedOff}
					/>
				);
			case ECRBRecordCode.CRBB:
				return (
					<CRBB1Preview
						crbRecord={recordToRender}
						isStrikedOff={isStrikedOff}
					/>
				);
			case ECRBRecordCode.CRBC:
				return (
					<CRBC1Preview
						crbRecord={recordToRender}
						isStrikedOff={isStrikedOff}
					/>
				);
			case ECRBRecordCode.CRBD:
				return (
					<CRBD1Preview
						crbRecord={recordToRender}
						isStrikedOff={isStrikedOff}
					/>
				);
			case ECRBRecordCode.CRBE:
				return (
					<CRBE1Preview
						crbRecord={recordToRender}
						isStrikedOff={isStrikedOff}
					/>
				);
			case ECRBRecordCode.CRBF:
				return (
					<CRBF1Preview
						crbRecord={recordToRender}
						isStrikedOff={isStrikedOff}
					/>
				);
			case ECRBRecordCode.CRBG:
				return (
					<CRBG1Preview
						crbRecord={recordToRender}
						isStrikedOff={isStrikedOff}
					/>
				);
			case ECRBRecordCode.CRBH:
				return (
					<CRBH1Preview
						crbRecord={recordToRender}
						isStrikedOff={isStrikedOff}
					/>
				);
			case ECRBRecordCode.CRBI:
				return (
					<CRBI1Preview
						crbRecord={recordToRender}
						isStrikedOff={isStrikedOff}
					/>
				);
			case ECRBRecordCode.CRBJ:
				return (
					<CRBJ1Preview
						crbRecord={recordToRender}
						isStrikedOff={isStrikedOff}
					/>
				);
			case ECRBRecordCode.CRBK0:
				return (
					<CRBK0Preview
						crbRecord={recordToRender}
						isStrikedOff={isStrikedOff}
					/>
				);
			case ECRBRecordCode.CRBK1:
				return (
					<CRBK1Preview
						crbRecord={recordToRender}
						isStrikedOff={isStrikedOff}
					/>
				);
			case ECRBRecordCode.CRBK2:
				return (
					<CRBK2Preview
						crbRecord={recordToRender}
						isStrikedOff={isStrikedOff}
					/>
				);
			default:
				return null;
		}
	}

	return renderMain();
}

export default CRBPreviewer;
